import {_import_} from './_import.js';
const url = 'overtime'; // 模块文件夹路径
const overtime = _import_(url + '/index');

export default [
  {
    path: '/overtime',
    name: 'overtime',
    meta: {
      title: {title: '测评', color: '#ffffff'},
      needLogin: false
    },
    component: overtime
  }
];



// WEBPACK FOOTER //
// ./src/router/overtime.js